import { Component, Fragment } from "react";

export const MensagemUsuarioAnonimo =	
	class extends Component {
		render() {
			return (
				<div className="painelAnonimo">
					<div className="mensagem">
						<Fragment>
							<p><b>Prezado usuário,</b></p>
							{this.props.children}
						</Fragment>
					</div>
				</div>
			);
		}
	}
		